import React, { useState, useContext, useCallback, useEffect } from "react";
import { Row, Col, Container, Button } from "reactstrap";
import { FormattedMessage, useIntl } from "react-intl";
import ExploreFeesCard from "./ExploreFees/ExploreFeesCard";
import { BillingTypes } from "../types/BillingTypes";
import { AppContext } from "services/appContext/AppContext";
import { BillingApi } from "services/apis/BillingApi";
import { handleError } from "services/util/ApiUtil";
import BreadcrumbHeader from "components/common/BreadcrumbHeader";
import AddOrUpdateExploreFees from "./ExploreFees/AddOrUpdateExploreFees";
import IconWithTooltip from "components/common/IconWithTooltip";
import { getTranslation } from "translations/TranslationService";
import { useLocation } from 'react-router-dom';

interface LocationState {
    companyId: string;
}

export default function Billing() {
  const [showModal, setShowModal] = useState(false);
  const [billingReports, setBillingReports] = useState<BillingTypes[]>([]);
  const [billingLoaded, setBillingLoaded] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const intl = useIntl();
  const { appContext } = useContext(AppContext);
  const theme = appContext.theme;

  const selectedCompanyId = appContext.localStorageInfo.selectedProfile?.companyId;

  const fetchBillingReports = useCallback((selectedCompanyId: string) => {
    BillingApi.list(selectedCompanyId)
      .then((result) => {
        setBillingReports(result);
      })
      .catch((error) => handleError(error))
      .finally(() => {
        setBillingLoaded(true);
      });
  }, []);

  useEffect(() => {
        if (selectedCompanyId) {
            fetchBillingReports(selectedCompanyId);
        }
    }, [fetchBillingReports, refreshTrigger]);

  // useEffect(() => {
  //   fetchBillingReports();
  // }, [fetchBillingReports]);

  return (
    <>
      <BreadcrumbHeader>
        <FormattedMessage id="billing.title" />
      </BreadcrumbHeader>
      {showModal && (
        <AddOrUpdateExploreFees
          companyId={appContext.localStorageInfo.selectedProfile?.companyId}
          closeModal={() => setShowModal(false)}
          onSuccess={() => {
            setShowModal(false);
            setRefreshTrigger(prev => prev + 1);
        }}
        />
      )}

      <Container fluid className="mb-2">
        <Row className="justify-content-center">
          <Col md="12" className="">
            <h1
              className={`display-3 mb-2 ${theme === "light" ? "lblue-color" : "pc-soa-order-bg"}`}>
              <FormattedMessage id="billing.title" />
              <IconWithTooltip
                className="fas fa-info-circle cursor-pointer mx-2 icon-font-size"
                tooltip={getTranslation(intl, "workqueue.info.tooltip")}
                tooltipClassName="custom-tooltip-background"
              />
            </h1>
          </Col>
        </Row>
      </Container>
      <Container fluid className="mt-1 mb-2">
        <Row className="align-items-center">
          <Col>
            <div className="d-flex align-items-center billing-tabs">
              <span className="mr-4 font-weight-bold">Explore Fees</span>
            </div>
          </Col>
          <Col xs="auto" className="billing-create-btn">
            <Button
              color={`${theme === "dark" ? "danger" : ""}`}
              className={`pc-btn create-btn ${theme === "light" ? "bg-lblue" : ""}`}
              onClick={() => {
                setShowModal(true);
              }}>
              <i className="fas fa-plus-square mr-2" />
              <FormattedMessage id="billing.createFee" />
            </Button>
          </Col>
        </Row>
      </Container>
      <Container fluid>
        <Row className="justify-content-center">
          <Col md="12">
            <ExploreFeesCard billingReports={billingReports} billingLoaded={billingLoaded} />
          </Col>
        </Row>
      </Container>
    </>
  );
}

const validateSearchValue = (): string => {
  return "";
};
